import React, { useEffect } from "react";
import Banner from "../components/trade/Banner";
import Conditions from "../components/trade/Conditions";
import Execution from "../components/trade/Execution";
import Coverage from "../components/trade/Coverage";
import Stability from "../components/trade/Stability";
import Security from "../components/trade/Security";
import TradeTools from "../components/trade/TradeTools";
import FAQ from "../components/trade/FAQ";
import CTA from "../components/trade/CTA";

function Trade() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="overflow-hidden pb-[80px] xl:pb-0">
      <Banner />
      <Conditions />
      <Execution />
      <Coverage />
      <Stability />
      <Security />
      <TradeTools />
      <FAQ />
      <CTA />
    </div>
  );
}

export default Trade;
